import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';

export const searchTranslation = TranslationBlueprint.make({
  name: 'search',
  params: {
    resource: createTranslationMessages({
      ref: searchTranslationRef,
      full: false,
      messages: {
        'searchModal.viewFullResults': 'Alle resultaten bekijken',
        'searchType.allResults': 'Alle resultaten',
        'searchType.tabs.allTitle': 'Alle',
        'searchType.accordion.allTitle': 'Alle',
        'searchType.accordion.collapse': 'Klap in',
        'searchType.accordion.numberOfResults': '{{number}} resultaten',
        'sidebarSearchModal.title': 'Zoeken',
      },
    }),
  },
});
